import { PROMPTBAR_PARTS } from './promptBarParts';
import type { PromptBarStyleConfig } from './types';

export const PROMPTBAR_STYLE_CONFIG: PromptBarStyleConfig = {
  parts: PROMPTBAR_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      p: 0,
      position: 'relative',
      flexShrink: 0,
    },
    textarea: {
      position: 'initial',
      border: 'none',
      pl: 1.5,
      pr: '2.825rem',
      py: '0.5rem',
      flexGrow: 1,
      minW: 0,
      fieldSizing: 'content',
      fontSize: 'md',
      lineHeight: 'md',
      width: '100%',
      // minHeight: '2',
      // minHeight: '5.75rem',
      _focus: {
        boxShadow: 'none',
        outline: 'none',
      },
    },
    submitButton: {
      outline: 'none',
      display: 'flex',
      direction: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    floatRight: {
      h: 5,
      w: 5,
      display: 'flex',
      direction: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      right: '0',
      top: '0',
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      pt: 1.0,
      px: 1.25,
      pb: 1.25,
      // borderTop: '1px solid',
      // borderColor: 'separator.divider',
    },
  },
  variants: {
    default: (props) => {
      const popoverShadow = props.theme.shadows.popover;
      const focusShadow = props.theme.shadows.focus;
      const combinedFocusShadow = `${popoverShadow}, ${focusShadow}`;

      return {
        container: {
          border: '1px solid',
          borderColor: 'separator.divider',
          borderRadius: 'lg',
          boxShadow: 'popover',
          transitionProperty: 'box-shadow',
          transitionDuration: 'normal',
          mx: 1.25,
          mb: 1.5,
          zIndex: 10,
          '&:has(textarea:focus)': {
            borderColor: 'interaction.main',
            boxShadow: combinedFocusShadow,
          },
        },
      };
    },
    borderless: {
      container: {
        border: 'none',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
};
